import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/Store";

export type VideoModalTab = "mockup" | "catalog-builder";

interface VideoModalState {
  isOpen: boolean;
  activeTab: VideoModalTab;
}

const initialState: VideoModalState = {
  isOpen: false,
  activeTab: "mockup",
};

const videoModalSlice = createSlice({
  name: "videoModal",
  initialState,
  reducers: {
    openVideoModal: (state, action: PayloadAction<VideoModalTab>) => {
      state.isOpen = true;
      state.activeTab = action.payload;
    },
    closeVideoModal: (state) => {
      state.isOpen = false;
    },
    setActiveVideoTab: (state, action: PayloadAction<VideoModalTab>) => {
      state.activeTab = action.payload;
    },
  },
});

export const { openVideoModal, closeVideoModal, setActiveVideoTab } =
  videoModalSlice.actions;

export default videoModalSlice.reducer;

export const selectIsVideoModalOpen = (state: RootState) =>
  state.videoModal.isOpen;
export const selectActiveVideoTab = (state: RootState) =>
  state.videoModal.activeTab;
